import moment from "moment";

const timeDifferenceHelper = (start, end, sound) => {
	// returns time difference in in minutes
	if (!start || !end) return false;
	start = start.split(":");
	end = end.split(":");
	var diff = new Date(0, 0, 0, end[0], end[1]).getTime() - new Date(0, 0, 0, start[0], start[1]).getTime();
	const hours = Math.floor(diff / 1000 / 60 / 60);
	diff -= hours * 1000 * 60 * 60;
	return hours * 60 + Math.floor(diff / 1000 / 60);
};

export const absTimeDifference = (start, end) => Math.abs(timeDifferenceHelper(start, end));

export const timeDifference = (start, end, sound) => {
	if (sound) {
		console.log(start, end);
		console.log(timeDifferenceHelper(start, end, sound));
	}
	return timeDifferenceHelper(start, end, sound);
};

export const timeNow = () => moment().format("HH:mm");
